/**
 * Идентификатор этого браузера — случайная строка в localStorage.
 *
 * Уходит на сервер заголовком `X-Device-Id` с каждым запросом (api/client.ts).
 * По нему сервер понимает, что два входа — с одного устройства (одна строка в
 * списке сессий, а не десять), и может устройство заблокировать: см.
 * backend_v2/auth.py, раздел «Сессии и устройства». Это не отпечаток железа:
 * очистка данных сайта выдаст новый идентификатор.
 */
const KEY = 'sb_device_id';

let cached: string | null = null;

export function deviceId(): string {
  if (cached) return cached;
  try {
    const v = localStorage.getItem(KEY);
    if (v && /^[A-Za-z0-9_-]{8,64}$/.test(v)) { cached = v; return v; }
  } catch { /* хранилище недоступно — идентификатор на время вкладки */ }
  const bytes = new Uint8Array(16);
  (globalThis.crypto || (window as any).msCrypto).getRandomValues(bytes);
  const id = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  try { localStorage.setItem(KEY, id); } catch { /* не запомнится */ }
  cached = id;
  return id;
}
